<style>
.zoom {
    -webkit-transform: scale(0.6);
    transform: scale(0.65);
    transform-origin: left top;
}
</style>

<template>
    <v-app id="kzona-app" v-bind:class="[browserName]" app-data="true">
        <dialog-idle v-model="idle"></dialog-idle>
        <dialog-alert></dialog-alert>
        <dialog-iframe></dialog-iframe>
        <the-institution></the-institution>
        <the-toolbar v-if="$oauth2.hasAccessToken()"></the-toolbar>
        <v-main>
            <router-view></router-view>
            <the-bottom v-if="$vuetify.breakpoint.mobile"></the-bottom>
        </v-main>
    </v-app>
</template>

<script>
import TheInstitution from '@gravela/vue-component-library/src/components/the-institution.vue'
import TheBottom from '@/components/the-bottom.vue'
import TheToolbar from '@/components/the-toolbar.vue'
import DialogIdle from '@/components/dialog-idle.vue'
import DialogAlert from '@/components/dialog-alert.vue'
import DialogIframe from '@gravela/vue-component-library/src/components/dialog-iframe.vue'
import CustomerMixin from '@/mixins/customer-mixin.js'
import InstitutionMixin from '@gravela/vue-component-library/src/mixins/institution-mixin.js'
import StorageMixin from '@/mixins/storage-mixin.js'

const {
    detect
} = require('detect-browser')

export default {
    name: 'App',
    mixins: [CustomerMixin, InstitutionMixin, StorageMixin],
    components: {
        'the-institution': TheInstitution,
        'the-bottom': TheBottom,
        'the-toolbar': TheToolbar,
        'dialog-alert': DialogAlert,
        'dialog-idle': DialogIdle,
        'dialog-iframe': DialogIframe
    },
    data() {
        return {
            idle: false,
            alert: true
        }
    },
    onIdle() {
        this.idle = !!this.hasCustomer
    },
    onActive() {
        this.idle = false
    },
    mounted() {
        Array.prototype.slice.apply(document.getElementsByTagName('dialog-iframe')).forEach(function (frame) {
            frame.contentWindow.document.addEventListener('click', function () {
            }, true)
        })
    },
    computed: {
        browserName() {
            const browser = detect()
            return browser !== null && browser !== undefined ? browser.name : ''
        }
    }
}
</script>
